import React from "react";
import { AuthThumb } from "../../assets/images/svg/svg";
import "./index.scss";
import Footer from "../../layout/footer";

function AuthLayout({ children }) {
  return (
    <>
      <div className="full--height">
        <div className="auth--area">
          <div className="auth--thumb">
            <AuthThumb />
          </div>
          <div className="auth--content--wrapper">
            <div className="auth--content">
              {children}
              <Footer className="auth-footer"/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthLayout;
